var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsLead(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_5877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55333 1.45337C8.37962 1.37413 8.19092 1.33313 8 1.33313C7.80907 1.33313 7.62037 1.37413 7.44666 1.45337L1.73333 4.05337C1.61503 4.10553 1.51445 4.19097 1.44384 4.29927C1.37323 4.40758 1.33563 4.53408 1.33563 4.66337C1.33563 4.79266 1.37323 4.91916 1.44384 5.02746C1.51445 5.13577 1.61503 5.22121 1.73333 5.27337L7.45333 7.88003C7.62704 7.95927 7.81574 8.00027 8.00666 8.00027C8.19759 8.00027 8.38629 7.95927 8.56 7.88003L14.28 5.28003C14.3983 5.22787 14.4989 5.14244 14.5695 5.03413C14.6401 4.92583 14.6777 4.79932 14.6777 4.67003C14.6777 4.54074 14.6401 4.41424 14.5695 4.30594C14.4989 4.19763 14.3983 4.1122 14.28 4.06003L8.55333 1.45337Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33335 8C1.33303 8.12751 1.36929 8.25244 1.43782 8.35997C1.50636 8.46749 1.60429 8.55311 1.72001 8.60667L7.45335 11.2133C7.62615 11.2916 7.81365 11.3321 8.00335 11.3321C8.19304 11.3321 8.38054 11.2916 8.55335 11.2133L14.2733 8.61333C14.3914 8.56029 14.4914 8.47406 14.5612 8.36516C14.6311 8.25625 14.6677 8.12937 14.6667 8",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33335 11.3334C1.33303 11.4609 1.36929 11.5858 1.43782 11.6933C1.50636 11.8009 1.60429 11.8865 1.72001 11.94L7.45335 14.5467C7.62615 14.625 7.81365 14.6654 8.00335 14.6654C8.19304 14.6654 8.38054 14.625 8.55335 14.5467L14.2733 11.9467C14.3914 11.8937 14.4914 11.8074 14.5612 11.6985C14.6311 11.5896 14.6677 11.4627 14.6667 11.3334",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsLead);
export default __webpack_public_path__ + "static/media/DevOpsLead.b325c87101199ce64c9e662435021fa0.svg";
export { ForwardRef as ReactComponent };